import { render, staticRenderFns } from "./M_databaseBackup.vue?vue&type=template&id=4bbb8eb3&scoped=true&"
import script from "./M_databaseBackup.vue?vue&type=script&lang=js&"
export * from "./M_databaseBackup.vue?vue&type=script&lang=js&"
import style0 from "./M_databaseBackup.vue?vue&type=style&index=0&id=4bbb8eb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb8eb3",
  null
  
)

export default component.exports